<script>
    import { formattedDateAndTime, fromNow } from "../../utils/date";

    import BasicContent from "../content/BasicContent.svelte";
    import EntityParentContent from "../content/EntityParentContent.svelte";
    import UpdatedFieldsContent from "../content/UpdatedFieldsContent.svelte";
    import TopicRoleContent from "../content/TopicRoleContent.svelte";

    export let activity = {};
</script>

<a class="activity" href={"#"}>
    <div class="activity-date" title={formattedDateAndTime(activity.createdOn)}>
        {fromNow(activity.createdOn)}
    </div>

    {#if activity.type === 0}
        <BasicContent content={activity.content} />
    {:else if activity.type === 1}
        <EntityParentContent content={activity.content} />
    {:else if activity.type === 2}
        <UpdatedFieldsContent content={activity.content} />
    {:else if activity.type === 3}
        <TopicRoleContent content={activity.content} />
    {/if}
</a>

<style>
    .activity {
        @apply flex flex-col gap-1 border-b bg-white p-2 hover:bg-gray-100 cursor-default;
    }

    .activity-date {
        @apply text-xs text-gray-400 cursor-default;
    }
</style>
